import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { IconEnum } from "@/modules/vue/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleButton',
  props: {
    modelValue: {
      type: Boolean
    },
    iconOn: {
      default: IconEnum.CheckRound
    },
    iconOff: {
      default: IconEnum.CloseOutline
    },
    typeOn: {
      default: 'success'
    },
    typeOff: {
      default: 'error'
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(_component_NButton, {
        secondary: "",
        type: __props.modelValue ? __props.typeOn : __props.typeOff,
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', !__props.modelValue))
      }, {
        default: _withCtx(() => [_createVNode(_component_Icon, {
          icon: __props.modelValue ? __props.iconOn : __props.iconOff
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["type"]);
    };
  }
});